"use strict";

document.addEventListener('DOMContentLoaded', _ => {
	// should be called on every page to transfer UTM codes from landing pages to other pages like forms.
	new UtmTracker();
}, {passive: true, once: true});

export default class UtmTracker {
	constructor() {
		this._UTMParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
		this._URLSearchParams = new URLSearchParams(window.location.search);

		this.updateStoredUTMParams();
		this.attachToAllLinks();
	}

	updateStoredUTMParams() {
		this._UTMParams.forEach(async param => {
			if (this._URLSearchParams.has(param)) {
				localStorage.setItem(param, this._URLSearchParams.get(param));
			} else {
				localStorage.removeItem(param);
			}
		})
	}

	getStoredUTMParams() {
		const utmItems = {};
		this._UTMParams.forEach(async param => {
			if (localStorage.getItem(param) !== null) {
				utmItems[param] = localStorage.getItem(param);
			}
		});
		return utmItems
	}

	attachToAllLinks() {
		const utmAttachedMarker = 'utm-attached';

		const currentUTMParams = this.getStoredUTMParams();
		const currentBaseUrl = new URL(document.URL).origin

		if (currentUTMParams) {
			document.querySelectorAll('a[href]:not([href^=\'tel:\']):not([href^=\'mailto:\']):not(.' + utmAttachedMarker + ')').forEach(linkElement => {
				let linkElementUrl
				if (linkElement.href.startsWith('http')) {
					linkElementUrl = new URL(linkElement.href)
				} else {
					linkElementUrl = new URL(linkElement.href, currentBaseUrl)
				}

				this._UTMParams.forEach(param => {
					if (param in currentUTMParams && !linkElementUrl.searchParams.has(currentUTMParams[param])) {
						linkElementUrl.searchParams.append(param, currentUTMParams[param])
					}
				})

				linkElement.href = linkElementUrl.href
				linkElement.classList.add(utmAttachedMarker);
			})
		}
	}
}
